import React from 'react';
import Loader from 'react-loader';
// for redux
import { connect } from 'react-redux';
class CustomLoader extends React.Component{
    render(){
        return(
            <div>
                <Loader
                    loaded = {this.props.loaderDataR}
                    lines={10}
                    length={10}
                    width={10}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className='spinner'
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"     
                 />
            </div>
        )
    }
}
// export default CustomLoader;
function mapStateToProps(state) {
    console.log("sss", state.loaderReducer)
    return { loaderDataR: state.loaderReducer.loaderValue }
  }
export default  connect(mapStateToProps)(CustomLoader);